import { render, staticRenderFns } from "./cdk-change.vue?vue&type=template&id=aa963fc8&scoped=true&"
import script from "./cdk-change.vue?vue&type=script&lang=js&"
export * from "./cdk-change.vue?vue&type=script&lang=js&"
import style0 from "./cdk-change.vue?vue&type=style&index=0&id=aa963fc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa963fc8",
  null
  
)

export default component.exports